import find from 'lodash/find';
import store from '@Store';
import { navigateTo } from '@Utils/navigation';
import { fullTextDocumentId as fullTextDocumentIdSelector } from '../HopintoSelectors';
import { setFullTextDocumentId as setFullTextDocumentIdAction } from '../HopintoActions';

const normalizeDocumentId = (documentId) => String(documentId || '').trim();

// Citation ids may carry a namespace prefix (`cit:123`) while the hopinto document id is bare.
export function isFullTextDocumentIdMatch(citationId, fullTextDocumentId) {
  const normalizedCitationId = normalizeDocumentId(citationId);
  const normalizedFullTextDocumentId = normalizeDocumentId(fullTextDocumentId);

  return (
    !!normalizedFullTextDocumentId &&
    (normalizedCitationId === normalizedFullTextDocumentId || normalizedCitationId.endsWith(`:${normalizedFullTextDocumentId}`))
  );
}

export function getFullTextDocumentId() {
  return fullTextDocumentIdSelector(store.getState());
}

export function setFullTextDocumentId(fullTextDocumentId) {
  return store.dispatch(setFullTextDocumentIdAction({ fullTextDocumentId }));
}

export function processResultsItemsForFullTextDocumentId(items) {
  const fullTextDocumentId = getFullTextDocumentId();
  const result = find(items, (item) => isFullTextDocumentIdMatch(item?.id, fullTextDocumentId));

  if (result) {
    const { fullTextUrl, fullTextCustom } = result;

    if (!fullTextUrl) {
      Logger.error('Hopinto/FullTextResults - invalid fullTextUrl', fullTextUrl);
      setFullTextDocumentId(null);
      return;
    }

    if (fullTextCustom) {
      setFullTextDocumentId(null);
      navigateTo(fullTextUrl);
    }
  }
}
